<template>
  <svg
    role="img"
    aria-label="moreepisodes icon"
    class="moreepisodes-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
  >
    <title>More Episodes</title>
    <path
      d="M21.99 6.59H21.43V5.98C21.43 4.46 20.19 3.22 18.67 3.22H6C4.48 3.22 3.25 4.46 3.25 5.98V18.61C3.25 20.13 4.49 21.36 6 21.36H6.57V21.97C6.57 23.49 7.81 24.72 9.32 24.72H21.99C23.51 24.72 24.74 23.48 24.74 21.97V9.34C24.74 7.82 23.5 6.59 21.99 6.59ZM4.75 18.61V5.98C4.75 5.29 5.31 4.72 6 4.72H18.67C19.36 4.72 19.93 5.28 19.93 5.98V18.61C19.93 19.3 19.37 19.86 18.67 19.86H6C5.31 19.86 4.75 19.3 4.75 18.61ZM23.25 21.97C23.25 22.66 22.69 23.22 22 23.22H9.33C8.64 23.22 8.08 22.66 8.08 21.97V21.36H18.68C20.2 21.36 21.44 20.12 21.44 18.61V8.09H22C22.69 8.09 23.25 8.65 23.25 9.34V21.97Z"
      fill="currentColor"
    />
    <path
      d="M14.88 11.4L10.82 9.07999C10.14 8.66999 9.26001 9.18999 9.26001 9.97999V14.63C9.26001 15.42 10.11 15.93 10.82 15.53L14.9 13.21C15.58 12.83 15.58 11.82 14.88 11.42V11.4Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.moreepisodes-icon {
  height: 28px;
  width: 28px;
}
</style>
